import IceClassType from "@/model/IceClassType"
import Ship from "@/model/Ship"
import ShipType from "@/model/ShipType"
import ShipService from "./ShipService"

class FileUploaderService {
    private static instance: FileUploaderService

    private constructor() {

    }

    public static getInstance(): FileUploaderService {
        if (FileUploaderService.instance == null) {
            FileUploaderService.instance = new FileUploaderService()
        }
        return FileUploaderService.instance
    }

    public processData(data: string) {
        const lines: Array<string> = data.split('\n')
        lines.forEach(line => {
            console.log("LineReaded:", line) 
            const elements:Array<string> = line.split(';')
            if (elements[0] === "SHIP") {
                const ship: Ship = new Ship();
                ship.id = ""
                ship.name = this.getElementString(elements, 1)
                ship.imo = this.getElementString(elements, 2)
                ship.shipType = new ShipType() // 3
                ship.iceClassType = new IceClassType() // 4
                
                ship.keelLaidDownDate = this.getElementDate(elements, 5)
                ship.contractSignInDate = this.getElementDate(elements, 6)
                ship.shipDeliveredDate = this.getElementDate(elements, 7)
    
                ship.gt = this.getElementInt(elements, 8)
                ship.dwt = this.getElementInt(elements, 9)
                ship.lpp = this.getElementInt(elements, 10)
                ship.loa = this.getElementInt(elements, 11)
                ship.cb = this.getElementInt(elements, 12)
                ship.manualVref = this.getElementInt(elements, 13)
                // ship.vrefapp = this.getElementInt(elements, 14)
                ship.bs = this.getElementInt(elements, 15)
                ship.ds = this.getElementInt(elements, 16)

                // ship.powerLimit = this.getElementInt(elements, 17)
                ship.displacementVolume = this.getElementInt(elements, 18)

                ship.has_vse = this.getElementBoolean(elements, 19)
                ship.lwtReferenceDesign = this.getElementInt(elements, 20)
                ship.lwtEnhancedDesign = this.getElementInt(elements, 21)
                ship.capacity = this.getElementInt(elements, 22)
                ship.capacityCorrection = this.getElementInt(elements, 23)

                // ship.has_cranes = this.getElementBoolean(elements, 24)
                ship.cranes = [] // 25

                ship.has_sideloaders = this.getElementBoolean(elements, 26)
                ship.capacityNoSideloaders = this.getElementInt(elements, 27)
                ship.capacitySideloaders = this.getElementInt(elements, 28)

                ship.has_roro_ramps = this.getElementBoolean(elements, 29)
                ship.capacityNoRORORamp = this.getElementInt(elements, 30)
                ship.capacityRORORamp = this.getElementInt(elements, 31)
                
                ship.has_csr = this.getElementBoolean(elements, 32)
                ship.lwtCsr = this.getElementInt(elements, 33)
                ship.dwtCsr = this.getElementInt(elements, 34)

                ship.vTanks = this.getElementInt(elements, 35)

                ShipService.getInstance().saveShip(ship)
            }
        })
    }

    getElementInt(elements: Array<string>, position: number) {
        let result = 0
        if (elements.length < position) {
            result = parseInt(elements[position])
        }
        return result
    }

    getElementString(elements: Array<string>, position: number) {
        let result = ""
        if (elements.length < position) {
            result = elements[position]
        }
        return result
    }

    getElementBoolean(elements: Array<string>, position: number) {
        let result = false
        if (elements.length < position) {
            const elementString = elements[position]
            result = elementString.toUpperCase() === 'TRUE' || elementString.toUpperCase() === '1' || elementString.toUpperCase() === 'SI' || elementString.toUpperCase() === 'SÍ'  || elementString.toUpperCase() === 'YES'
        }
        return result
    }

    getElementDate(elements: Array<string>, position: number) {
        let result = new Date()
        if (elements.length < position) {
            const dateElements: Array<string> = elements[position].split("-")
            if (dateElements.length == 3) {
                result = new Date(parseInt(dateElements[0]), parseInt(dateElements[1]), parseInt(dateElements[2]))
            }
        }
        return result
    }
}

export default FileUploaderService